import * as actions from '../redux/actions';

import React, { Component, useEffect, useState } from 'react';

import CommonService from '../../../../services/commonService';
import DateService from '../../../../services/dateService';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// import CommonService from '../../../../../services/commonService';







function PaymentRightSideBar(props) {
  let countryCodes = [];
  let paymentGatewayList = '';
  let idCardTypes = [];

  const [mobileError, setMobileError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [confirmEmailError, setConfirmEmailError] = useState(null);
  const [selectedPaymentGateway, setSelectedPaymentGateway] = useState(null);
  const [showBookingConfirmModal, setShowBookingConfirmModal] = useState(false);
  const [wallet, setWallet] = useState(false);
  const [walletMoney, setWalletMoney] = useState(0);
  const [confirmTabSelected, setConfirmTabSelected] = useState(1);

  // COMPONENT DID UPDATE
  useEffect(() => {
    for (let c of props.home.metaData.country_codes) {
      countryCodes.push({
        id: c,
        name: '+' + c,
      });
    }
    paymentGatewayList = CommonService.copyObject(props.home.metaData.payment_gate_way_list_v1);
  });

  const renderSummaryDetailsCard = (service, date, source, dest, title) => {
    return (
      <div className="summary-details">
        <div className="journey-date flex-row">
          <div className="kupos-button-secondary">{title}</div>
          <span className="date">
            {date
              ? DateService.getDayNameFromDate(date) +
              ', ' +
              DateService.getDateFromDate(date) +
              ' ' +
              DateService.getMonthNameFromDate(date)
              : ''}
          </span>
        </div>
        <div className="op-name">{service.route ? service.route.operator_service_name : ''}</div>
        <div className="location-details">
          <div className="city-name">
            <img
              className="icon-source"
              src="/images/icons/home/icon_source.png"
              alt={props.t('TRANSLATIONS.ICON_SOURCE')}
            />
            <span>{source ? source.label : ''}</span>
          </div>
          <div className="address">
            {service.boardingStage
              ? service.boardingStage.landmark +
              ' - ' +
              DateService.ampm(service.boardingStage.time)
              : ''}
          </div>
        </div>
        <div className="location-details">
          <div className="city-name">
            <img className="icon-source" src="/images/icons/home/icon_source2.png" />
            <span>{dest ? dest.label : ''}</span>
          </div>
          <div className="address">
            {service.droppingStage
              ? service.droppingStage.landmark +
              ' - ' +
              DateService.ampm(service.droppingStage.time)
              : ''}
          </div>
        </div>
      </div>
    );
  };

  let selectedServiceOnward =
    props.pbServiceList && props.pbServiceList.selectedServiceOnward
      ? props.pbServiceList.selectedServiceOnward
      : {};
  let onwardPBDate = props.home ? props.home.onwardPBDate : null;
  let destCityOnward = props.home ? props.home.pbDestinationCity : null;
  let sourceCityOnward = props.home ? props.home.pbSourceCity : null;

  let selectedServiceReturn =
    props.pbServiceList && props.pbServiceList.selectedServiceReturn
      ? props.pbServiceList.selectedServiceReturn
      : {};
  let returnPBDate = props.home ? props.home.returnPBDate : null;
  let sourceCityReturn = props.home ? props.home.pbDestinationCity : null;
  let destCityReturn = props.home ? props.home.pbSourceCity : null;

  console.log({ props })
  return (
    <div className="pb-service-list-payment-right-side-bar journey-summary-sidebar">
      <div className="kupos-card">
        <div className="summary-title">Summary</div>
        {renderSummaryDetailsCard(
          selectedServiceOnward,
          onwardPBDate,
          sourceCityOnward,
          destCityOnward,
          'Going',
        )}
        {returnPBDate
          ? renderSummaryDetailsCard(
            selectedServiceReturn,
            returnPBDate,
            sourceCityReturn,
            destCityReturn,
            'Return',
          )
          : null}
      </div>

      <div className="kupos-card payment-details-sidebar">
        <div className="payment-sidebar-title">
          Payment <span className="bold">details</span>
        </div>
        <div className="payment-seats">
          <div>Seats:</div>
          {props.pbServiceList && props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook
            ? props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook.map((val, key) => {
              return (
                <div key={key} className="payment-seat-row flex-row">
                  <div>
                    <span className="bold">{val.number},</span>{' '}
                    {CommonService.capitalize(val.type)}:
                  </div>
                  <div>${val.net_amount}</div>
                </div>
              );
            })
            : null}
          {props.pbServiceList && props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook
            ? props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook.map((val, key) => {
              return (
                <div key={key} className="payment-seat-row flex-row">
                  <div>
                    <span className="bold">{val.number},</span>{' '}
                    {CommonService.capitalize(val.type)}:
                  </div>
                  <div>${val.net_amount}</div>
                </div>
              );
            })
            : null}
        </div>
        <div className="discount-block fl">
          <div className="discount-row flex-row">
            <div>Discount:</div>
            <div className="secondary-text">
              {props.pbServiceList && props.pbServiceList.bookingDetailsOnward
                ? props.pbServiceList.bookingDetailsOnward.discountAmount
                : ''}
            </div>
          </div>
          <div className="discount-row flex-row">
            <div>Promo code:</div>
            <div className="secondary-text">-1,000</div>
          </div>
          <div className="promocode font10">Caja Los Hereos</div>
        </div>
        <div className="subtotal-block">
          <div className="subtotal-row flex-row">
            <div className="primary-text">Subtotal:</div>
            <div className="primary-text bold">
              $
              {(props.pbServiceList && props.pbServiceList.bookingDetailsOnward
                ? props.pbServiceList.bookingDetailsOnward.totalBookingAmount
                : 0) +
                (props.pbServiceList && props.pbServiceList.bookingDetailsReturn
                  ? props.pbServiceList.bookingDetailsReturn.totalBookingAmount
                  : 0)}
            </div>
          </div>
          <div className="subtotal-row flex-row">
            <div className="primary-text">Amount in USD:</div>
            <div className="primary-text bold">${props.calculateNetFareUSD()}</div>
          </div>
        </div>
      </div>

      <div className="total bold">
        <div className="total-row flex-row">
          <div>Total</div>
          <div>${props.calculateNetFare()}</div>
        </div>
      </div>
    </div>
  );
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pbServiceList: state.pbServiceList,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentRightSideBar);


// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusServiceList/PaymentRightSideBar/PaymentRightSideBar.js